import { useEffect, Component, useState, useRef } from "react"
import { api } from './utils/api';
import uuid from 'react-uuid'
import "./styles/orderreview.css"

class StarRating extends Component {

  constructor(props) {
      super(props);

      this.state = {
          stars: [],
          rating: 3,
          hovered: 0,
          selectedIcon: "★",
          deselectedIcon: "☆"
      };

      let outOf = props.outOf ? props.outOf : 5;

      for (var i = 0; i < outOf; i++) {
          this.state.stars.push(i + 1);
      }
  }

  changeRating(newRating) {
      this.setState({
          rating: newRating
      });

      if (this.props.onChange)
          this.props.onChange(newRating);
  }

  hoverRating(rating) {
      this.setState({
          hovered: rating
      });
  }

  render() {

      const { stars, rating, hovered, deselectedIcon, selectedIcon } = this.state;

      return (
        <div className="rating">
          {stars.map(star => {
            return (
                <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => { this.changeRating(star); }}
                    // onMouseEnter={() => { this.hoverRating(star); }}
                    // onMouseLeave={() => { this.hoverRating(0); }}
                    key={uuid()}
                >
                    {rating < star ?
                        hovered < star ? deselectedIcon : selectedIcon
                        :
                        selectedIcon
                    }
                </span>
            );
          })}
        </div>
      );
  }
}

function ReviewItem({item, handlePostReview}) {
  const [rating, changeRating] = useState(3)
  const reviewRef = useRef()
  
  const handleclickPost = () => {
    if (!reviewRef.current.value) {
      alert("要寫評價喔~~")
      return
    }
    handlePostReview(rating, reviewRef.current.id, reviewRef.current.value)
  }
  return(
    <div className="review__item" >
      <div className="review__item__info">
        <img src={item.main_image} className="item__main-image details" alt="product" />
        <div className='item__info review'>
          <div className="item__info__title">{item.title}</div>
          <div className="item__info__id review">{item.id}</div>
          <div className="item__info__colorwrap">
            <div className="item__info__colorcode" style={{backgroundColor: `#${item.color.code}`}}></div>
            <div className="item__info__colorname">{item.color.name}</div>
            <div className="item__info__size">{item.size}</div>
          </div>
          
          <div className="item__info__pricewrap">
            <div className="item__info__qty">x {item.qty}</div>
            <div className="item__info__price">TWD.{item.price}</div>
          </div>
        </div>
      </div>
      <div className="review__item__review">
        <StarRating onChange={changeRating} rating={rating}/>
        <div className="review__inputwrap">
          <textarea className="review__input" type="text" id={item.uuid} ref={reviewRef} placeholder="我覺得..."/>
        </div>
      </div>
      <button className="review__postBtn" onClick={handleclickPost}>送出評論</button>
    </div>
  )
}

export default function OrderReview() {
  const [orderDetails, setOrderDetails] = useState([])
  const [allOrderReview, setAllOrderReview] = useState("")
  // const [reviewData, setReviewData] = useState([])
  const [orderId] = useState(window.location.search.split("=")[1])
  const [currentIndex, setCurrentIndex] = useState(0)
  // const [isFirst, setIsFirst] = useState(true)
  useEffect(() => {
    api.getOrderList(localStorage.getItem("aws_JWT"), orderId)
    .then((res) => {
      let data =  res.data[0].details.map((item) => {
        delete item.image
        delete item.stock
        delete item.name
        item.uuid = uuid()
        return item
      })
      return data
    })
    .then((data) => {
      setOrderDetails(data)
      setAllOrderReview(data.length)
      // let reviews =  data.map((item) => {
      //   item = null
      //   return item
      // })
      // setReviewData(reviews)
    })
  }, [])

  const handlePostReview = (rating, uuid, value) => {
    let currentProduct= orderDetails.filter((item) =>{
      return item.uuid === uuid
    })
    currentProduct[0] = {...currentProduct[0]}
    delete currentProduct[0].main_image
    delete currentProduct[0].uuid
    currentProduct[0].order_id = orderId
    currentProduct[0].rating = rating
    currentProduct[0].comment = value

    api.postOrderReview(localStorage.getItem("aws_JWT"), currentProduct)
    .then((res) => console.log(res))

    setCurrentIndex(currentIndex + 1)
    renderView(uuid)
  }

  const renderView = (uuid) => {
    let newData =  orderDetails.filter((item) => {
      return item.uuid !== uuid
    })
    setOrderDetails(newData)
  }
  return(
    <>
      <div className="orderDetail__finished">
        <div>發表評價 {`(${currentIndex}/${allOrderReview})`}</div>
      </div>
      <div className="review__wrap">
      {/* <ReviewItem orderDetails={orderDetails} reviewData={reviewData} changeRating={changeRating} reviewRef={reviewRef} setIsFirst={setIsFirst} isFirst={isFirst} /> */}
        { orderDetails.length === 0 ?
          <div className="review__thanku">謝謝你的評論 啾咪</div>
         : orderDetails.map((item) => 
          <ReviewItem item={item} key={item.id} handlePostReview={handlePostReview}/>
        )}
      </div>
      {/* <button className="review__postBtn" onClick={handlePostReview}>送出評論</button> */}
    </>
  )
}